export interface IGeneracionSnp {
  id?: string;
  cveGeneracion?: string;
  fechaGeneracion?: string;
}

export class GeneracionSnp implements IGeneracionSnp {
  constructor(public id?: string, public cveGeneracion?: string, public fechaGeneracion?: string) {}

  static fromObject(item: IGeneracionSnp): GeneracionSnp {
    const generacion = new GeneracionSnp();

    for (const [key, value] of Object.entries(item)) {
      generacion[key] = value;
    }
    return generacion;
  }
}

export interface IRelacionAlumnoSnp {
  generacion?: string;
  alumnos?: number;
  alumnosConBaja?: number;
  alumnosConGrado?: number;
  alumnosActivos?: number;
  porcentajeConBaja?: number;
  porcentajeConGrado?: number;
  porcentajeActivos?: number;
}

export class RelacionAlumnoSnp implements IRelacionAlumnoSnp {
  constructor(
    public generacion?: string,
    public alumnos?: number,
    public alumnosConBaja?: number,
    public alumnosConGrado?: number,
    public alumnosActivos?: number,
    public porcentajeConBaja?: number,
    public porcentajeConGrado?: number,
    public porcentajeActivos?: number
  ) {}

  static fromObject(item: IRelacionAlumnoSnp): RelacionAlumnoSnp {
    const generacion = new RelacionAlumnoSnp();

    for (const [key, value] of Object.entries(item)) {
      generacion[key] = value;
    }
    return generacion;
  }
}

export interface IListarGeneracionSnp {
  generacion?: GeneracionSnp;
  relacionAlumno?: RelacionAlumnoSnp;
}

export class ListarGeneracionSnp implements IListarGeneracionSnp {
  constructor(public generacion?: GeneracionSnp, public relacionAlumno?: RelacionAlumnoSnp) {}
}
